<template>
  <el-card
    class="thridlog-chart-item"
    shadow="never"
    :body-style="{ padding: '10px' }"
  >
    <el-table
      :data="items"
      :row-key="row => row.index + '_' + row.id"
      size="mini"
      :show-header="false"
    >
      <el-table-column label="No" width="50" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>

      <el-table-column label="URL" show-overflow-tooltip>
        <div slot-scope="s">
          <span class="item-method">{{ s.row.method }}</span>
          <span class="item-url"
            >{{ s.row.path }}{{ s.row.query ? '?' : '' }}{{ s.row.query }}</span
          >
        </div>
      </el-table-column>

      <el-table-column prop="occurrenceTimeStr" label="调用时间" width="220">
        <div slot-scope="s" class="item-right">
          <span>{{ s.row.occurrenceTimeStr }}</span>
          <span class="item-elapsed-time">({{ s.row.elapsedTime }}ms)</span>
        </div>
      </el-table-column>

      <el-table-column width="50">
        <div slot-scope="s" class="item-right">
          <el-button
            type="text"
            size="mini"
            :loading="s.row.loading"
            @click="lookup(s.row)"
          >
            查看
          </el-button>
        </div>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    lookup(row) {
      this.$emit('loadrequest', row)
    },
  },
}
</script>

<style lang="scss" scoped>
.thridlog-chart-item {
  border: none;

  .item-method {
    margin-right: 5px;
    font-weight: bold;
  }

  .item-elapsed-time {
    // text-align: right;
    font-weight: bold;
    margin-left: 5px;
  }

  .item-right {
    text-align: right;
  }
}
</style>
